import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'

import { OtpModal } from '../../Components/Modals/OtpModal';
import { Link, useParams } from 'react-router-dom';
import { Sidebar } from '../../Components/Sidebar';
import { BsChevronLeft } from 'react-icons/bs';
import axiosInstance from '../../utils/axiosConfig';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

export const ConsentDetails = () => {
    const [showOtpModal, setShowOtpModal] = useState(false);
    const handleOtpModal = () => setShowOtpModal(true);
    const [loader, setLoader] = useState(true)
    const [data, setData] = useState(null)
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        axiosInstance().post(
            'consent-api/gspUserdetail',
            {
                gspUserId: id
            }
       ).then((res) => {
        if([200].includes(res.data?.code)) {
            setLoader(false)
            // res.data.gspUserList.map((item) => {
            //     gspUsers.push({
            //         id: item.gspUserData.id,
            //         title: item.gspUserData.name,
            //         pan_no: item.gspUserData.pan,
            //         gst_no: item.gspUserData.gstin,
            //         gsp_code: item.gspUserData.gsp,
            //         created_on: item.gspUserData.created_at,
            //         created_by: 'Nayan Brar',
            //         varification_status: item.gspUserData.is_active ? 'Active' : 'De-active',
            //         validity_until: item.gspUserData?.valid_date ? item.gspUserData?.valid_date : '08/27'
            //     })
            // })
            setData(res.data.gspUserDetail)
        } else {
            toast.error(res.data?.message)
            setLoader(false)
        }
       }).catch(err => {
            console.log(err)
            setLoader(false)
       })
    }, [id]);

    // const deleteConsent = (id) => {
    //     const promise = axiosInstance().post(
    //         'api/gspUserDelete',
    //         {
    //             gspUserId: String(id)
    //         }
    //     )
    //     toast.promise(
    //         promise,
    //         {
    //             loading: 'Deleting...',
    //             success: (res) => {
    //                 if([200].includes(res.data?.code)) {
    //                     // return <b>{res.data.message}</b>
    //                     navigate('/manage-consent', { replace: true });
    //                 } else {
    //                     return <b>{res.data.message}</b>
    //                 }
    //             },
    //             error: (err) => {
    //                 return <b>{err.toString()}</b>
    //             }
    //         }
    //     );
    // }

    return (
        <>
        <Container fluid className='p-4'>
            <Row>
                <Col md={3}>
                    <Sidebar
                        title={'Details consent'}
                        subTitle={'Enter company details '}
                        ctaText={'Need help to generate new consent?'}
                    />
                </Col>
                <Col md={7} className='offset-1'>
                    <Link to={'/manage-consent'} className='fw-bold mt-4 mb-5 d-inline-block text-decoration-none ms-n1'>
                        <BsChevronLeft className='me-1' />Back
                    </Link>
                    {
                        loader ? <div className='d-flex justify-content-center align-items-center' style={{height: '100%'}}>
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div> : <div>
                            <Row className='mb-4'>
                                <Col md={12}>
                                    <p className="mb-0">Corporate Name</p>
                                    <h2 className="fw-bold">{data?.name}</h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>GSTIN Number</small></p>
                                    <p className='mb-0 fw-medium'>{data?.gstin}</p>
                                </Col>
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>PAN Number</small></p>
                                    <p className='mb-0 fw-medium'>{data?.pan}</p>
                                </Col>
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>GSP Code</small></p>
                                    <p className='mb-0 fw-medium'>{data?.gsp}</p>
                                </Col>
                            </Row>
                            <hr className='my-4' />
                            <Row>
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>Created On</small></p>
                                    <p className='mb-0 fw-medium'>{moment(data?.created_at).format('DD/MM/YYYY')}</p>
                                </Col>
                               
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>Last Updated On</small></p>
                                    <p className='mb-0 fw-medium'>{moment(data?.updated_at).format('DD/MM/YYYY')}</p>
                                </Col>
                                {/* <Col md={3} lg={2}>
                                    <p className='mb-0 text-black-50'><small>Credential Type</small></p>
                                    <p className='mb-0 fw-medium'></p>
                                </Col> */}
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>Verification Status</small></p>
                                    <p className='mb-0 fw-medium'>{data?.is_active ? 'Active' : 'De-active'}</p>
                                </Col>
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>Validity Until</small></p>
                                    <p className='mb-0 fw-medium'>{moment(data?.extra_data.validuntill).format('MM/YYYY')}</p>
                                </Col>
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>Created By</small></p>
                                    <p className='mb-0 fw-medium'>{data?.created_by_id}</p>
                                </Col>
                            </Row>
                            <hr className='my-4' />
                            <Row>
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>Username</small></p>
                                    <p className='mb-0 fw-medium'>{data?.username}</p>
                                </Col>
                                
                                
                                
                                {/* <Col md={3} lg={2}>
                                    <p className='mb-0 text-black-50'><small>Email ID</small></p>
                                    <p className='mb-0 fw-medium'>{data?.email}</p>
                                </Col> */}
                                <Col md={3} lg={3}>
                                    <p className='mb-0 text-black-50'><small>Mobile</small></p>
                                    <p className='mb-0 fw-medium'>{data?.mobile_number}</p>
                                </Col>
                                {/* <Col md={3} lg={2}>
                                    <p className='mb-0 text-black-50'><small>Channel</small></p>
                                    <p className='mb-0 fw-medium'>{data?.extra_data.ref}</p>
                                </Col> */}
                                {/* <Col md={3} lg={2}>
                                    <p className='mb-0 text-black-50'><small>Password</small></p>
                                    <p
                                    contentEditable={false} // Make the <p> tag read-only
                                    style={{ outline: 'none' }} // Remove outline
                                    className='mb-0 fw-medium'
                                >
                                   {data?.password ? '********' : ''} 
                                </p>
                                </Col> */}
                            </Row>
                            <Row className='mt-5'>
                                <Col>
                                    {/* <Button variant='outline-dark px-5' href='/manage-consent'>Confirm</Button> */}
                                    {/* <Button variant='outline-dark px-5 ms-2' onClick={() => {
                            toast((t) => (
                                <div>
                                    <div>Do you want to delete? <b style={{ fontSize: '14px'}}>{data.gstin}</b></div>
                                    <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'end', paddingRight: '30px;'}}> <button onClick={() => toast.dismiss(t.id)}>
                                        Cancel
                                    </button>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button onClick={() => {
                                        deleteConsent(id)
                                        toast.dismiss(t.id)
                                    }}>
                                        Confirm
                                    </button>
                                    </div>
                                </div>
                            ), {
                                duration: 4000000,
                                style: {
                                    width: '350px'
                                },
                            });
                        }}>Delete</Button> */}
                                </Col>
                            </Row>
                        </div>
                    }
                </Col>
            </Row>
        </Container>

        <OtpModal showOtpModal={showOtpModal} setShowOtpModal={setShowOtpModal} />
        </>
    )
}
